import { ProductManager } from '~~/shared/services/commerce/ProductManager';

export default defineNuxtPlugin(async (nuxtApp) => {
  const productManager = await ProductManager.createProductManager(
    process.env.NODE_ENV === 'production' ? 'production' : 'sandbox',
  );
  nuxtApp.provide('productManager', productManager);
});
